/**
 * @file Homepage Ctas.
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * Homepage Ctas component.
 */
const vHpCtas = () => {
	const hpCtas = document.querySelector('.v-hp-ctas');

	if (!hpCtas) {
		return;
	}

	gsap.registerPlugin(ScrollTrigger);

	const ctas = hpCtas.querySelectorAll('.v-hp-ctas__item-content');
	const ctaBgs = hpCtas.querySelectorAll('.v-hp-ctas__item-bg');
	// const mm = gsap.matchMedia().add();

	gsap.matchMedia().add({
		isDesktop: '(min-width: 921px)',
		isTablet: '(min-width: 551px) and (max-width: 920px)',
		isMobile: '(max-width: 550px)',
	}, (ctx) => {
		const { isDesktop, isTablet, isMobile } = ctx.conditions;
		const ctaTl = gsap.timeline({
			defaults: {
				ease: 'power1.inOut',
			},
			scrollTrigger: {
				trigger: hpCtas,
				start: 'top bottom-=10%',
				end: isDesktop ? 'bottom bottom' : 'top center',
				scrub: true,
			},
		});
		let xPercent = -40;
		let yPercent = 40;

		if (isTablet || isMobile) {
			xPercent = isTablet ? -20 : -10;
			yPercent = isTablet ? 20 : 10;
		}

		ctaTl
			.from(ctas, { xPercent })
			.from(ctaBgs, { yPercent }, '<');
	});
};

export default vHpCtas;
